import React, { useRef } from "react"
import { motion, AnimatePresence } from "framer-motion"

// Quello che cambia sul posto dentro un foglio — un passo del modulo, lo
// sport che si guarda — esce a sinistra ed entra da destra, uno dopo
// l'altro. `value` dice cosa si sta mostrando.
//
// Chi entra ha una chiave nuova ogni volta, anche quando torna uno già
// visto. Tornando su un passo mentre sta ancora uscendo — Indietro toccato
// nei 0,18 secondi dell'animazione, il tasto indietro del telefono, due sport
// toccati in fretta — framer-motion 11.3 lo trova tra quelli che escono, non
// lo fa rientrare e aspetta un'uscita che non finisce più: il riquadro
// restava vuoto. Con una chiave nuova quello che esce finisce di uscire, e
// quello che entra entra.
export default function StepSwap({ value, children }) {
	const turn = useRef({ value, count: 0 })
	if (turn.current.value !== value) turn.current = { value, count: turn.current.count + 1 }

	return (
		<AnimatePresence mode="wait">
			<motion.div
				key={turn.current.count}
				initial={{ opacity: 0, x: 12 }}
				animate={{ opacity: 1, x: 0 }}
				exit={{ opacity: 0, x: -12 }}
				transition={{ duration: 0.18 }}>
				{children}
			</motion.div>
		</AnimatePresence>
	)
}
